import React from "react";
import { ASSETS } from "../../data/assets";
import { PillButton } from "./PillButton";

export function EmptyState({ title, message, ctaLabel, onCta, image = ASSETS.trioHore }) {
  return (
    <div className="flex flex-col items-center text-center py-12 px-6" data-testid="empty-state">
      <img src={image} alt="" className="w-40 sm:w-52 mb-4 animate-float drop-shadow-xl" />
      <h3 className="font-display text-2xl sm:text-3xl text-sea-deep">{title}</h3>
      {message && <p className="mt-2 text-sea-deep/70 font-semibold max-w-md">{message}</p>}
      {ctaLabel && (
        <PillButton className="mt-6" onClick={onCta} data-testid="empty-state-cta">
          {ctaLabel}
        </PillButton>
      )}
    </div>
  );
}
